/** Ícone e ordem das áreas (SPEC-v2 8.2): tile em lucide, traço 1,75. */
import type { Area } from '@rota/contracts';
import { Aperture, Clapperboard, LayoutDashboard, type LucideIcon, MessagesSquare } from 'lucide-react';

export const AREA_ORDER: readonly Area[] = ['painel', 'automacoes', 'estudio', 'palco'];

export const AREA_ICON: Readonly<Record<Area, LucideIcon>> = {
  painel: LayoutDashboard,
  automacoes: MessagesSquare,
  estudio: Aperture,
  palco: Clapperboard,
};

/** Atalho `g 1` a `g 4` (SPEC-v2 2.4; Palco é a 4ª área, docs/palco/SPEC.md 4). */
export function areaIndex(area: Area): number {
  return AREA_ORDER.indexOf(area) + 1;
}
